export default "__VITE_ASSET___$fXb54P__"